<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex
                    xs12
                >
                    <mobile-accordion/>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    import MobileAccordion from './../../Calculators/MyCover/Summaries/MobileAccordion';
    import MyCoverMixin from "../../Calculators/MyCover/mycover";

    export default {
        data() {
            return {
                loading: true,
                quotation: {},
            }
        },

        mixins: [
            MyCoverMixin
        ],

        components: {
            MobileAccordion
        },

        props: ['itemInfo'],
        name: 'Quotation-Summary',
        mounted() {
            this.$store.commit('calculators/setCurrentStep', 4);

            this.quotation = this.itemInfo;

            const client = {
                benefactor_type: this.quotation.request.benefactor,
                lpp_type: this.quotation.request.lpp
            };

            this.$store.commit('mycover/setClient', client);

            this.$store.commit('mycover/setBenefits', this.quotation.response);
            this.$store.commit('mycover/setBenefitsRequested', true);

            this.$store.dispatch('calculators/getAll');
            this.$store.dispatch('mycover/getResources')
                .then(response => {
                    this.loading = false;
                });
        },
    }
</script>
